import React from "react";

interface Props {
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

export const Logo: React.FC<Props> = ({ className, onClick, style }) => (
  <svg
    viewBox="0 0 269.724 46.999878"
    version="1.1"
    id="svg5"
    xmlns="http://www.w3.org/2000/svg"
    className={className ?? ""}
    onClick={onClick}
    style={style}
  >
    <defs id="defs2">
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath23">
        <path d="M 0,252 H 850 V 0 H 0 Z" id="path21" />
      </clipPath>
    </defs>
    <g id="layer1" transform="translate(-0.19985447,-2.0155274)">
      <g
        id="g19"
        clipPath="url(#clipPath23)"
        transform="matrix(0.35277777,0,0,-0.35277777,-13.605398,70.492162)"
      >
        <g id="g25" transform="translate(79.1113,130.8945)">
          <path
            d="m 0,0 h 19.218 c 2.152,0 3.844,1.691 3.844,3.844 v 7.687 c 0,2.153 -1.692,3.844 -3.844,3.844 H 0 Z m 0,-30.749 h -7.687 v 53.811 h 26.905 c 3.152,0 5.92,-1.153 8.148,-3.382 2.231,-2.23 3.383,-4.996 3.383,-8.149 V 3.844 c 0,-3.152 -1.152,-5.919 -3.383,-8.149 -2.228,-2.229 -4.996,-3.382 -8.148,-3.382 L 0,-7.687 Z"
            style={{
              fill: "currentColor",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path27"
          />
        </g>
        <g id="g29" transform="translate(144.4512,130.8945)">
          <path
            d="m 0,0 c 2.152,0 3.844,1.691 3.844,3.844 v 7.687 c 0,2.153 -1.692,3.844 -3.844,3.844 H -19.218 V 0 Z m 10.454,-14.605 c 0.692,-0.769 1.077,-1.692 1.077,-2.691 V -30.749 H 3.844 v 11.915 L -7.149,-7.687 h -12.069 v -23.062 h -7.687 V 23.062 H 0 c 3.151,0 5.919,-1.153 8.148,-3.382 2.23,-2.23 3.383,-4.996 3.383,-8.149 V 3.844 c 0,-5.228 -3.46,-9.61 -8.38,-11.07 z"
            style={{
              fill: "currentColor",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path31"
          />
        </g>
        <g id="g33" transform="translate(175.1982,146.2695)">
          <path
            d="m 0,0 c -2.153,0 -3.844,-1.691 -3.844,-3.844 v -30.749 c 0,-2.153 1.691,-3.844 3.844,-3.844 h 15.374 c 2.152,0 3.844,1.691 3.844,3.844 V -3.844 C 19.218,-1.691 17.526,0 15.374,0 Z m 0,-46.124 c -3.152,0 -5.92,1.153 -8.149,3.382 -2.23,2.229 -3.382,4.997 -3.382,8.149 v 30.749 c 0,3.153 1.152,5.919 3.382,8.149 C -5.92,6.534 -3.152,7.687 0,7.687 h 15.374 c 3.151,0 5.919,-1.153 8.148,-3.382 2.23,-2.23 3.383,-4.996 3.383,-8.149 v -30.749 c 0,-3.152 -1.153,-5.92 -3.383,-8.149 -2.229,-2.229 -4.997,-3.382 -8.148,-3.382 z"
            style={{
              fill: "currentColor",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path35"
          />
        </g>
        <g id="g37" transform="translate(217.4756,100.1455)">
          <path
            d="m 0,0 h -7.687 v 11.531 c 0,1.076 0.384,1.998 1.152,2.691 l 29.597,29.673 v 9.917 H 30.75 V 42.28 c 0,-1.076 -0.385,-1.999 -1.154,-2.69 L 0,9.916 Z"
            style={{
              fill: "currentColor",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path39"
          />
        </g>
        <g id="g41" transform="translate(267.4404,100.0684)">
          <path
            d="m 0,0 c -3.152,0 -5.92,1.153 -8.148,3.383 -2.231,2.229 -3.383,4.996 -3.383,8.148 V 42.28 c 0,3.153 1.152,5.92 3.383,8.15 2.228,2.228 4.996,3.382 8.148,3.382 h 15.375 c 3.151,0 5.919,-1.154 8.148,-3.382 2.229,-2.23 3.383,-4.997 3.383,-8.15 v -3.843 h -7.687 v 3.843 c 0,2.153 -1.692,3.844 -3.844,3.844 H 0 c -2.152,0 -3.844,-1.691 -3.844,-3.844 V 11.531 C -3.844,9.379 -2.152,7.687 0,7.687 h 15.375 c 2.152,0 3.844,1.692 3.844,3.844 v 7.226 l -11.686,2.767 1.768,7.457 14.607,-3.459 c 1.768,-0.384 2.998,-1.921 2.998,-3.69 V 11.608 c 0,-3.152 -1.154,-5.92 -3.383,-8.149 C 21.294,1.23 18.526,0.077 15.375,0.077 Z"
            style={{
              fill: "currentColor",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path43"
          />
        </g>
        <g id="g45" transform="translate(309.7178,123.207)">
          <path
            d="m 0,0 h 23.062 v 2.922 l -10.07,20.14 H 10.07 L 0,2.922 Z M 30.365,5.535 C 30.596,4.997 30.75,4.459 30.75,3.844 V -23.062 H 23.062 V -7.687 H 0 V -23.062 H -7.687 V 3.844 c 0,0.615 0.154,1.153 0.384,1.691 L 4.229,28.598 c 0.691,1.46 1.844,2.152 3.458,2.152 h 7.688 c 1.614,0 2.768,-0.692 3.459,-2.152 z"
            style={{
              fill: "currentColor",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path47"
          />
        </g>
        <g id="g49" transform="translate(367.3701,135.2002)">
          <path
            d="m 0,0 11.531,18.757 h 7.688 V -35.055 H 11.531 V 4.074 L 3.844,-8.38 H -3.844 L -11.53,4.074 v -39.129 h -7.688 v 53.812 h 7.688 z"
            style={{
              fill: "currentColor",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path51"
          />
        </g>
        <g id="g53" transform="translate(432.71,146.2695)">
          <path
            d="m 0,0 h -30.749 v -15.375 h 23.062 v -7.687 H -30.749 V -38.437 H 0 v -7.687 H -38.437 V 7.687 H 0 Z"
            style={{
              fill: "currentColor",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path55"
          />
        </g>
        <g id="g57" transform="translate(467.3008,130.8945)">
          <path
            d="m 0,0 c 2.152,0 3.844,1.691 3.844,3.844 v 7.687 c 0,2.153 -1.692,3.844 -3.844,3.844 H -19.218 V 0 Z m 10.454,-14.605 c 0.692,-0.769 1.077,-1.692 1.077,-2.691 V -30.749 H 3.844 v 11.915 L -7.149,-7.687 h -12.069 v -23.062 h -7.687 V 23.062 H 0 c 3.151,0 5.919,-1.153 8.148,-3.382 2.23,-2.23 3.383,-4.996 3.383,-8.149 V 3.844 c 0,-5.228 -3.46,-9.61 -8.38,-11.07 z"
            style={{
              fill: "currentColor",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path59"
          />
        </g>
        <g id="g61" transform="translate(498.0479,100.1455)">
          <path
            d="m 0,0 c -3.152,0 -5.92,1.153 -8.149,3.382 -2.23,2.229 -3.382,4.997 -3.382,8.149 v 2.383 h 7.687 V 11.531 C -3.844,9.378 -2.153,7.687 0,7.687 h 15.374 c 2.152,0 3.844,1.691 3.844,3.844 v 3.767 c -0.077,1.153 -0.769,2.075 -1.999,2.767 L -5.459,28.981 c -4.305,2.383 -6.072,6.457 -6.072,9.456 v 3.843 c 0,3.153 1.152,5.919 3.382,8.149 2.229,2.229 4.997,3.383 8.149,3.383 h 15.374 c 3.151,0 5.919,-1.154 8.148,-3.383 2.23,-2.23 3.383,-4.996 3.383,-8.149 v -2.383 h -7.687 v 2.383 c 0,2.153 -1.692,3.844 -3.844,3.844 H 0 c -2.153,0 -3.844,-1.691 -3.844,-3.844 v -3.766 c 0.076,-1.154 0.768,-2.076 1.998,-2.768 L 20.832,24.83 c 4.305,-2.383 6.073,-6.457 6.073,-9.455 v -3.844 c 0,-3.152 -1.153,-5.92 -3.383,-8.149 C 21.293,1.153 18.525,0 15.374,0 Z"
            style={{
              fill: "currentColor",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path63"
          />
        </g>
        <g id="g65" transform="translate(559.29,100.0684)">
          <path
            d="m 0,0 c -3.152,0 -5.919,1.153 -8.148,3.383 -2.23,2.229 -3.383,4.996 -3.383,8.148 V 42.28 c 0,3.153 1.153,5.92 3.383,8.15 2.229,2.228 4.996,3.382 8.148,3.382 h 15.375 c 3.152,0 5.92,-1.154 8.148,-3.382 2.231,-2.23 3.383,-4.997 3.383,-8.15 v -3.843 h -7.687 v 3.843 c 0,2.153 -1.692,3.844 -3.844,3.844 H 0 c -2.152,0 -3.844,-1.691 -3.844,-3.844 V 11.531 C -3.844,9.379 -2.152,7.687 0,7.687 h 15.375 c 2.152,0 3.844,1.692 3.844,3.844 v 7.226 l -11.686,2.767 1.77,7.457 14.605,-3.459 c 1.768,-0.384 2.998,-1.921 2.998,-3.69 V 11.608 c 0,-3.152 -1.152,-5.92 -3.383,-8.149 C 21.295,1.23 18.527,0.077 15.375,0.077 Z"
            style={{
              fill: "currentColor",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path67"
          />
        </g>
        <g id="g69" transform="translate(620.7861,130.8945)">
          <path
            d="m 0,0 c 2.152,0 3.844,1.691 3.844,3.844 v 7.687 c 0,2.153 -1.692,3.844 -3.844,3.844 H -19.219 V 0 Z m 10.455,-14.605 c 0.691,-0.769 1.076,-1.692 1.076,-2.691 V -30.749 H 3.844 v 11.915 L -7.148,-7.687 h -12.071 v -23.062 h -7.687 V 23.062 H 0 c 3.152,0 5.92,-1.153 8.148,-3.382 2.231,-2.23 3.383,-4.996 3.383,-8.149 V 3.844 c 0,-5.228 -3.459,-9.61 -8.379,-11.07 z"
            style={{
              fill: "currentColor",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path71"
          />
        </g>
        <g id="g73" transform="translate(651.5322,146.2695)">
          <path
            d="m 0,0 c -2.152,0 -3.844,-1.691 -3.844,-3.844 v -30.749 c 0,-2.153 1.692,-3.844 3.844,-3.844 h 15.375 c 2.152,0 3.844,1.691 3.844,3.844 V -3.844 C 19.219,-1.691 17.527,0 15.375,0 Z m 0,-46.124 c -3.152,0 -5.92,1.153 -8.148,3.382 -2.229,2.229 -3.383,4.997 -3.383,8.149 v 30.749 c 0,3.153 1.154,5.919 3.383,8.149 C -5.92,6.534 -3.152,7.687 0,7.687 h 15.375 c 3.152,0 5.92,-1.153 8.148,-3.382 2.231,-2.23 3.383,-4.996 3.383,-8.149 v -30.749 c 0,-3.152 -1.152,-5.92 -3.383,-8.149 -2.228,-2.229 -4.996,-3.382 -8.148,-3.382 z"
            style={{
              fill: "currentColor",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path75"
          />
        </g>
        <g id="g77" transform="translate(716.8721,153.957)">
          <path
            d="m 0,0 h 7.687 v -42.28 c 0,-0.462 0,-0.923 -0.076,-1.384 -0.306,-2.384 -1.461,-4.612 -3.459,-6.611 -1.998,-2.077 -4.304,-3.229 -6.918,-3.46 -0.384,-0.077 -0.693,-0.077 -1.076,-0.077 h -15.375 c -0.385,0 -0.693,0 -1.076,0.077 -2.615,0.231 -4.92,1.383 -6.996,3.46 -1.922,1.999 -3.074,4.227 -3.383,6.611 -0.076,0.461 -0.076,0.922 -0.076,1.384 V 0 h 7.687 v -42.28 c 0,-1.769 2.075,-3.844 3.844,-3.844 h 15.375 c 1.844,0 3.842,2.075 3.842,3.844 z"
            style={{
              fill: "currentColor",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path79"
          />
        </g>
        <g id="g81" transform="translate(739.9326,130.8945)">
          <path
            d="m 0,0 h 19.219 c 2.152,0 3.842,1.691 3.842,3.844 v 7.687 c 0,2.153 -1.69,3.844 -3.842,3.844 H 0 Z m 0,-30.749 h -7.687 v 53.811 h 26.906 c 3.15,0 5.918,-1.153 8.148,-3.382 2.229,-2.23 3.381,-4.996 3.381,-8.149 V 3.844 c 0,-3.152 -1.152,-5.919 -3.381,-8.149 -2.23,-2.229 -4.998,-3.382 -8.148,-3.382 L 0,-7.687 Z"
            style={{
              fill: "currentColor",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path83"
          />
        </g>
        <path
          d="M 52.133,73.879 H 790.705 V 181.107 H 52.133 Z m 745.072,-13 H 45.633 l -6.5,6.5 v 120.228 l 6.5,6.5 h 751.572 l 6.5,-6.5 V 67.379 Z"
          style={{
            fill: "currentColor",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none",
          }}
          id="path85"
        />
      </g>
    </g>
  </svg>
);

export default Logo;
